import React from 'react';
import { CtaBlock } from './CtaBlock';
export function FinalCtaSection() {
  return <section className="w-full bg-editorial-bgAlt py-section-mobile md:py-section-desktop px-6 md:px-8 border-t border-editorial-divider relative overflow-hidden" data-id="element-46">
      {/* Subtle red gradient overlay */}
      <div className="absolute inset-0 bg-gradient-to-b from-transparent to-editorial-accent/10 pointer-events-none" data-id="element-47" />

      <div className="max-w-3xl mx-auto flex flex-col items-center text-center relative z-10" data-id="element-48">
        <h2 className="text-4xl md:text-5xl lg:text-6xl font-serif font-bold text-editorial-text leading-tight mb-8" data-id="element-49">
          This book doesn't ask for permission.
        </h2>

        <p className="text-lg md:text-xl font-sans text-editorial-textMuted mb-12 max-w-2xl leading-relaxed" data-id="element-50">
          It documents what happened, how it happened, and what it means for
          every American who still believes that the right to think differently
          is worth protecting.
        </p>

        <div className="bg-red-900 rounded-lg px-6 py-4 md:px-8 md:py-5 mb-6 w-full max-w-lg" data-id="element-51">
          <p className="text-sm md:text-base font-sans font-bold text-white text-center leading-relaxed" data-id="element-52">
            First Edition Price: $13.99 — Limited availability at this price.
          </p>
        </div>

        <div className="w-full max-w-md mb-12" data-id="element-53">
          <CtaBlock buttonText="Read the Full Book — $13.99" data-id="element-54" />
        </div>

        <p className="text-xs font-sans text-editorial-textMuted opacity-60 max-w-xl mx-auto" data-id="element-55">
          This work presents analysis and perspective for informational and
          educational purposes only.
        </p>
      </div>
    </section>;
}